export default __webpack_public_path__ + "assets/João Vitor da Silva Monteiro.cc0b3baa.pdf";